<template>
	<div v-loading="loading" :element-loading-text="$t('bc.bc_51')"
		element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.4)">
		<div class="reservebg">
			<p>{{$t('Reservesub.Reservesub_1')}}</p>
			<span>{{showText1}}</span>
			<div class="reservesub">
				<p>{{showText2}}</p>
				<p>{{showText3}}</p>
			</div>
		</div>
	</div>
</template>


<script>
	export default {
		name: 'Reservesub',
		inject: ['reload'],
		components: {

		},
		data() {
			return {
				showText1:this.$t('Reservesub.Reservesub_2'),
				showText2:this.$t('Reservesub.Reservesub_3'),
				showText3:this.$t('Reservesub.Reservesub_4'),
				loading: true,
				univapayChargeId: null,
				lang: 0
			};
		},
		watch: {},
		computed: {},
		methods: {
			goBack() {
				this.$router.push('/')
			},
		},
		created() {
			// 在 created 生命周期中获取并存储 univapayChargeId 和 univapayTokenId
			this.univapayChargeId = this.$route.query.univapayChargeId;

			console.log('univapayChargeId:', this.univapayChargeId);
			if (this.$i18n.locale == 'ja') {
				this.lang = 0
			} else if (this.$i18n.locale == 'zh') {
				this.lang = 1
			} else if (this.$i18n.locale == 'en') {
				this.lang = 2
			}
			console.log('123:', 123);
			this.$api.post(this.$config.Get_TKA, {
					'sChargeId': this.univapayChargeId,  
					'sLang': this.lang
				},
				// 请求成功
				success => {
					console.log('success.KKSTR:', success.KKSTR);
					if (success.KKSTR == 'Y') {
						this.showText1 = this.$t('Reservesub.Reservesub_2')
						this.showText2 = this.$t('Reservesub.Reservesub_3')
						this.showText3 = this.$t('Reservesub.Reservesub_4')
						this.$message.success(this.$t('bc.bc_19'));
					} else {
						this.showText1 = this.$t('Reservesub.Reservesub_5')
						this.showText2 = this.$t('Reservesub.Reservesub_6')
						this.showText3 = this.$t('Reservesub.Reservesub_7')						
						this.$message.error(this.$t('bc.bc_20'))
					}
					
				},
				// 请求失败
				error => {
					console.log(error)
				}
			)
			this.loading = false
		},
		mounted() {
			if (window.history && window.history.pushState) {
				history.pushState(null, null, document.URL);
				window.addEventListener('popstate', this.goBack, false);
			}
		},

		destroyed() {
			window.removeEventListener('popstate', this.goBack, false);
		}
	}
</script>


<style scoped>
	@media only screen and (min-width:680px) {
		.reservebg {
			width: 80%;
			margin: 0 auto;
			margin-top: 70px;
			text-align: center;
		}

		.reservebg>p {
			font-size: 70px;
			font-family: Roboto-Bold, Roboto;
		}

		.reservebg>span {
			font-size: 20px;
			font-family: Noto Sans CJK JP-Bold, Noto Sans CJK JP;
			margin-bottom: 30px;
			display: block;
			margin-top: 10px
		}
	}

	@media only screen and (max-width:680px) {
		.reservebg {
			width: 90%;
			margin: 0 auto;
			margin-top: 40px;
			text-align: center;
		}

		.reservebg>p {
			font-size: 46px;
			font-family: Roboto-Bold, Roboto;
		}

		.reservebg>span {
			font-size: 18px;
			font-family: Noto Sans CJK JP-Bold, Noto Sans CJK JP;
			margin-bottom: 30px;
			display: block;
			margin-top: 10px
		}
	}

	.reservesub {
		font-size: 14px;
		font-family: Noto Sans CJK JP-Bold, Noto Sans CJK JP;
		line-height: 28px
	}
</style>